<template>
  <button type="button" class="btn btn-secondary" @click="showModal()"><font-awesome-icon icon="plus" /> Auswählen</button>

  <div
    class="modal fade"
    id="selectDruckvorlagenModal"
    tabindex="-1"
    aria-labelledby="selectDruckvorlagenModal"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    ref="modalRef"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="selectDruckvorlagenModalLabel">Druckvorlagen auswählen</h5>
          <button type="button" class="btn-close" @click="closeModal()"></button>
        </div>

        <div class="modal-body">
          <div class="mb-2" v-for="(druckvorlage, index) in displayDruckvorlagen" :key="index">
            <input class="form-check-input me-3 my-auto" type="checkbox" :value="druckvorlage" :id="'druckvorlage-' + index" v-model="selectedVorlagen" />
            <label class="form-check-label flex-fill" :for="'druckvorlage-' + index">
              {{ getDruckvorlageTitel(druckvorlage) }}
            </label>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-3 float-end" @click="setVorlagen()">Ok</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, ref } from 'vue';
  import { Modal } from 'bootstrap';
  import { Druckvorlage } from '@/models/DruckvorlageModels';
  //#endregion

  const props = defineProps({
    vorlagen: {
      type: Object as PropType<Array<number>>,
      default: new Array<number>(),
    },
    druckvorlagen: {
      type: Array as PropType<Array<Druckvorlage>>,
      required: true,
    },
  });

  const emit = defineEmits(['setSelectedVorlagen']);

  const selectedVorlagen = ref(props.vorlagen);

  const displayDruckvorlagen = ref<Array<number>>(props.druckvorlagen.map((d) => d.id));

  function getDruckvorlageTitel(id: number): string {
    const druckvorlage = props.druckvorlagen.find((d) => d.id == id);
    return druckvorlage != null ? druckvorlage.titel : 'Unbekannte Druckvorlage';
  }

  function setVorlagen() {
    emit('setSelectedVorlagen', selectedVorlagen.value);
    closeModal();
  }

  //#region Modal
  const modalRef = ref();
  function closeModal() {
    Modal.getInstance(modalRef.value)?.hide();
  }
  function showModal() {
    if (modalRef.value) {
      new Modal(modalRef.value).show();
    }
  }
  //#endregion
</script>

<style scoped>
  .artikel-row:hover {
    cursor: pointer;
    color: #2a579b;
    background-color: #dfe9f8 !important;
  }
</style>
